import defaultProductSelectSettings from '@/settings/placeholder/product-select';
import {ProductSelectSectionSettings} from '@/settings/types';
import {createContext} from 'preact';

const ProductSelectSettings = createContext<ProductSelectSectionSettings>(
  defaultProductSelectSettings
);
export default ProductSelectSettings;
